export default "__VITE_ASSET__8df9a83a__"